function footerNavSlide() {
  const sliderBlocks = document.querySelectorAll('.footer__block')

  sliderBlocks.forEach(sliderBlock => {
    const sliderIcon = sliderBlock.querySelector('.footer__nav-icon')
    const subBlock = sliderBlock.querySelector('.footer__sub-block')

    if (sliderIcon && subBlock) {

      sliderIcon.addEventListener('click', function() {

        const isVisible = subBlock.offsetHeight > 0

        if (isVisible) {
          // スライドアップ
          subBlock.style.height = '0'
          sliderIcon.classList.remove('-is-active')
          setTimeout(() => {
            subBlock.style.display = 'none'
          }, 300)
        } else {
          // スライドダウン
          subBlock.style.display = 'flex'
          const fullHeight = subBlock.scrollHeight + 'px'
          subBlock.style.height = '0'
          subBlock.offsetHeight // 強制リフロー
          subBlock.style.transition = 'height 300ms'
          subBlock.style.height = fullHeight
          sliderIcon.classList.add('-is-active')
        }
      })
    }
  })
}

export default footerNavSlide